import styles from "./PrintCardsButton.module.css";
import React, { useState } from "react";
import { FaPrint } from "react-icons/fa";
import PastilleIcon from "../../CssIcon/PastilleIcon/PastilleIcon";
import { PrintCardsModal } from "../../Modal/PrintCardsModal/PrintCardsModal";
import { usePrintCartProvider } from "../../../context/PrintCartProvider";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import sidebarStyles from "../../Sidebar/Sidebar.module.css";

export const PrintCardsButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { items } = usePrintCartProvider();
  const { t } = useTranslation();

  return (
    <>
      <NavLink
        className={sidebarStyles.navLink}
        to="#"
        onClick={() => setIsOpen(true)}
      >
        <FaPrint />
        <div className={styles.pastilleContainer}>
          {items.length > 0 && <PastilleIcon>{items.length}</PastilleIcon>}
        </div>
        <div className={styles.label}>{t("print.label")}</div>
      </NavLink>
      <PrintCardsModal isOpen={isOpen} handleClose={() => setIsOpen(false)} />
    </>
  );
};
